import React from 'react';
import icons from '../../../../../../shared/utils/files/antIcons';
import { SortDirection } from 'react-virtualized';
import CustomHeaderCell from './CustomHeaderCell';

export default () =>
  ({
    /* eslint-disable react/prop-types */
    columnData,
    dataKey,
    disableSort,
    label,
    sortBy,
    sortDirection,
    /* eslint-enable react/prop-types */
  }) => {
    const sortIcon = sortDirection === SortDirection.ASC ? icons.asc : icons.desc;
    const sortIconElement = dataKey === sortBy ? sortIcon : null;

    return (
      <CustomHeaderCell
        columnData={columnData}
        dataKey={dataKey}
        disableSort={disableSort}
        label={label}
        sortBy={sortBy}
        sortDirection={sortDirection}
        onColumnResize={columnData.onColumnResize}
        onSort={columnData.onSort}
        sortIcon={sortIcon}
        sortIconElement={sortIconElement}
      />
    );
  };
